import React from 'react';
import TitleBar from '../../../containers/TitleBar';
import Dropdown from '../../../components/Dropdown';
import { __ } from '../../../core/utils';
import styles from '../../../styles/views/timesheets/TimesheetEntriesHeader.scss';
import classNames from 'classnames';
import ArrowDownSmallIcon from '../../../assets/images/arrow-down-small-15x15.svg';
import { hideDropdown } from '../../../redux/actions/general/dropdown';

const TimesheetEntriesHeader = ({
  users,
  selectedUserId,
  onUserChange,
  weekLabel,
  weekRange,
  prevWeekLabel,
  nextWeekLabel,
  onPrevWeek,
  onToday,
  onNextWeek,
  viewModes,
  viewMode,
  onViewModeChange,
}) => {
  const activeUser = users.find(
    (user) => Number(user.value) === Number(selectedUserId)
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.topRow}>
        <div className={styles.topRowInner}>
          <div className={styles.titleSection}>
            <TitleBar
              title={__('Timesheet')}
              dropdownHeader={__('submenu.title.time-log-main')}
              customStyles={styles.titleBar}
            />
            <div className={styles.selectField}>
              <Dropdown
                name='timesheet_entries_selected_user'
                top={50}
                leftStyled
                header={
                  <div className={styles.dropdownHeader}>
                    {__('Select user')}
                  </div>
                }
                content={
                  <div className={styles.dropdownContent}>
                    {users.map((user) => (
                      <div
                        key={user.value}
                        className={classNames(
                          styles.dropdownItem,
                          Number(user.value) === Number(selectedUserId) &&
                            styles.dropdownItemActive
                        )}
                        onClick={() => {
                          onUserChange && onUserChange(Number(user.value));
                          hideDropdown();
                        }}
                      >
                        <span>{user.label}</span>
                        <div className={styles.dropdownDot} />
                      </div>
                    ))}
                  </div>
                }
              >
                <div className={styles.selectTrigger}>
                  <span className={styles.selectValue}>
                    {activeUser?.label || __('Select user')}
                  </span>
                  <ArrowDownSmallIcon className={styles.selectArrow} />
                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.bottomRow}>
        <div className={styles.bottomRowInner}>
          <div className={styles.weekMeta}>
            <div className={styles.weekLabel}>{weekLabel}</div>
            <div className={styles.weekRange}>{weekRange}</div>
          </div>

          <div className={styles.weekActions}>
            <button
              type='button'
              className={styles.navButton}
              onClick={onPrevWeek}
            >
              {prevWeekLabel}
            </button>
            <button
              type='button'
              className={styles.navButton}
              onClick={onToday}
            >
              {__('timesheet_entries.header.today')}
            </button>
            <button
              type='button'
              className={styles.navButton}
              onClick={onNextWeek}
            >
              {nextWeekLabel}
            </button>
          </div>

          <div className={styles.viewSwitch}>
            {viewModes.map((mode) => (
              <button
                key={mode.value}
                type='button'
                className={classNames(
                  styles.viewButton,
                  viewMode === mode.value && styles.viewButtonActive
                )}
                onClick={() => onViewModeChange(mode.value)}
              >
                {mode.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimesheetEntriesHeader;
